(() => {
  new Swiper('.js-featured-blog-swiper', {
    slidesPerView: 'auto',
    spaceBetween: 30,
    init: true,
    slidesOffsetBefore: 20,
    slidesOffsetAfter: 20,
    breakpoints: {
      250: {
        spaceBetween: 20
      },
      990: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      1201: {
        slidesPerView: 4
      }
    },
    pagination: {
      el: ".js-featured-blog-pagination",
      type: "bullets",
      clickable: false,
      renderBullet: function (index = 0, className = 'test') {
        return `<span class="${className} js-featured-blog-swiper-bullets"></span>`;
      },
    },
    navigation: {
      nextEl: '.js-featured-blog__swiper-next',
      prevEl: '.js-featured-blog__swiper-prev',
    }
  })

  let bullets = document.querySelectorAll('.js-featured-blog-swiper-bullets');
  

  Array.prototype.forEach.call(bullets, function (bullet) {
    bullet.style.width = `calc(100% / ${bullets.length})`
  })

  window.addEventListener("resize", (event) => {

    bullets = document.querySelectorAll('.js-featured-blog-swiper-bullets');
    
    Array.prototype.forEach.call(bullets, function (bullet) {
      bullet.style.width = `calc(100% / ${bullets.length})`
    })
  });
})();